import React from "react";
import SimplePage from "../../shared/SimplePage";

export default function Faq() {
  return <SimplePage title="FAQ" />;
}
